var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    _vm._b(
      {
        attrs: { filterable: "", clearable: "", placeholder: _vm.placeholder },
        scopedSlots: _vm._u(
          [
            _vm._l(_vm.$slots, function (slot, slotName) {
              return {
                key: slotName,
                fn: function () {
                  return [_vm._t(slotName)]
                },
                proxy: true,
              }
            }),
          ],
          null,
          true
        ),
        model: {
          value: _vm.selectedValue,
          callback: function ($$v) {
            _vm.selectedValue = $$v
          },
          expression: "selectedValue",
        },
      },
      "el-select",
      _vm.$attrs,
      false
    ),
    _vm._l(_vm.list, function (item) {
      return _c("el-option", {
        key: item.userId,
        attrs: {
          label: item.userName,
          value: item.userId,
          disabled: item.disabled,
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }